import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";


export default function AddNewUser() {
  const { t } = useTranslation();
  const generatePassword = () => {
    return Math.random().toString(36).slice(-8); // Генерація випадкового 8-символьного пароля
  };
  const location = useLocation();

  const [formData, setFormData] = useState({
    email: "",
    password: generatePassword(),
    firstName: "",
    lastName: "",
    phone: ""
  });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const firstName = queryParams.get("first_name");
    const lastName = queryParams.get("last_name");


    setFormData((prevData) => ({
      ...prevData,
      firstName: firstName || prevData.firstName,
      lastName: lastName || prevData.lastName,
    }));
  }, [location.search]);


  useEffect(() => {
    setFormData((prevData) => ({ ...prevData, password: generatePassword() }));
  }, []);

  const validate = () => {
    let errors = {};
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      errors.email = t("emailWarning");
    }
    if (!formData.firstName.trim().match(/^[A-Za-z]+$/)) {
      errors.firstName = t("nameWarning");
    }
    if (!formData.lastName.trim().match(/^[A-Za-z]+$/)) {
      errors.lastName = t("surnameWarning");
    }
    if (!formData.phone.match(/^\+48\d{9}$/)) {
      errors.phone = t("phoneWarning");
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (!validate()) return;

    try {
      const response = await fetch("https://godrive.com.pl/api/users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, role: "new" })
      });
      const data = await response.json();
      if (response.ok) {
        const loginUrl = "https://godrive.com.pl/login";
        const userInfo = `${t("userCreated")}\n${t("email")} ${formData.email}\n${t("password")} ${formData.password}\n${t("loginPage")} ${loginUrl}`;
        navigator.clipboard.writeText(userInfo);
        alert(t("clipboardMessage"));
        window.location.href = "/admin/users";
      } else {
        setMessage(data.error || t("newUserError"));
      }
    } catch (error) {
      setMessage(t("servConError"));
    }
  };

  return (
    <div className="container mt-5">
      <div className="mx-auto" style={{ maxWidth: "500px" }}>
        <h2 className="text-center">{t("addNewUser")}</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">{t("email")}</label>
            <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">{t("password")}</label>
            <input type="text" className="form-control" name="password" value={formData.password} disabled />
          </div>
          <div className="mb-3">
            <label htmlFor="firstName" className="form-label">{t("name")}</label>
            <input type="text" className="form-control" name="firstName" value={formData.firstName} onChange={handleChange} required />
            {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
          </div>
          <div className="mb-3">
            <label htmlFor="lastName" className="form-label">{t("surname")}</label>
            <input type="text" className="form-control" name="lastName" value={formData.lastName} onChange={handleChange} required />
            {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">{t("phone")}</label>
            <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} required />
            {errors.phone && <div className="text-danger">{errors.phone}</div>}
          </div>
          <button type="submit" className="btn btn-primary w-100">{t("add")}</button>
        </form>
        {message && <p className="text-center text-danger mt-3">{message}</p>}
      </div>
    </div>
  );
}
